import { memo } from 'react';

import { parseTextToReact } from 'helpers/HtmlHelpers';

export const HtmlText = ({ text }) => {
  if (text) {
    return parseTextToReact(text);
  }
  return null;
};

export default memo(HtmlText);
